const NotFound = () => {
    return (
      <div className="h-screen">
        <h1 className="text-center">404 - Page Not Found</h1>
        <p className="text-center">Sorry, the page you are looking for could not be found.</p>
      </div>
    );
};

export default NotFound;